<template>
  <div class="container padding_large">
    <PageHeader />
    <div
      v-if="checking"
      class="center-protected checking-password"
      v-html="svgIcons.preloader"
    ></div>
    <div v-else class="center-protected">
      <h2>Dette innholdet er passordbeskyttet</h2>
      <p class="protected-intro">
        Skriv inn passordet du har fått eller
        <router-link to="/kontakt-oss/">ta kontakt med oss</router-link>.
      </p>
      <form class="password-form" @submit.prevent="unlockPage">
        <input
          type="password"
          placeholder="Passord"
          v-model="pass"
          required
          @input="error = false"
        />
        <button class="btn btn-primary" type="submit">
          Lås opp
        </button>
      </form>
      <p v-if="error" class="password-error">Feil passord. Prøv igjen.</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getStoredPasswords, rememberPassword } from "@/plugins/helpers";

export default {
  name: "pass-protection",
  data() {
    return {
      pass: null,
      error: false,
      checking: false
    };
  },
  computed: {
    ...mapGetters(["currentPostType"]),
    unlockTarget() {
      // Use the locked object's own type: an archive page is type "page"
      // even though the route meta carries the CPT (inspirasjon, video, ...),
      // and wp/v2/<cpt>/<pageId> would 404.
      return {
        id: this.currentPage ? this.currentPage.id : this.currentPageID,
        type:
          this.currentPage && this.currentPage.type
            ? this.currentPage.type
            : this.currentPostType
      };
    }
  },
  created() {
    // Auto-retry remembered passwords: with a shared section password the
    // form never shows after the first unlock. On success the parent view's
    // v-if on protection.locked flips and this component unmounts.
    if (getStoredPasswords().length) {
      this.checking = true;
      this.tryStoredPasswords(this.unlockTarget).then(() => {
        this.checking = false;
      });
    }
  },
  methods: {
    ...mapActions(["unlockPost", "tryStoredPasswords"]),
    unlockPage() {
      const payload = { ...this.unlockTarget, password: this.pass };
      this.unlockPost(payload).then(success => {
        if (success) {
          rememberPassword(this.pass);
        } else {
          this.error = true;
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/vars.scss";

.center-protected {
  text-align: center;
  input {
    border: 2px solid #323232;
    padding: 8px 10px;
  }
  .protected-intro {
    margin-bottom: 20px;
    a {
      font-weight: 700;
      color: $fontColor;
      text-decoration: underline;
      &:hover {
        color: $purple;
      }
    }
  }
  .password-error {
    margin-top: 15px;
    font-weight: 700;
    color: #790000;
  }
  &.checking-password {
    svg {
      margin: 0 auto;
      display: block;
    }
  }
}
</style>
